import React, { memo } from 'react';

import MaterialTextField from '../../MaterialTextField/MaterialTextField';
import { usePassengerInfoField } from './usePassengerInfoField';
import { useStyles } from './useStyles';

export const PassengerInfoField = memo((props) => {
    const { passengerInfo, recordId, name, defaultValue, editPassengerInfo, onChangeValue, required, validator } = props;
    const { errorText, handleInputFocus, handleInfoChange } = usePassengerInfoField(
        passengerInfo,
        recordId,
        name,
        defaultValue,
        editPassengerInfo,
        onChangeValue,
        required,
        validator
    );
    const classes = useStyles();

    return (
        <MaterialTextField
            label=""
            placeholder="0"
            name={name}
            fullWidth={true}
            defaultValue={defaultValue}
            onBlur={handleInfoChange}
            onFocus={handleInputFocus}
            className={classes.field}
            helperText={errorText}
            error={Boolean(errorText)}
            inputProps={{ className: classes.input }}
            type="number"
        />
    );
});

PassengerInfoField.displayName = 'PassengerInfoField';
